/************************************
MODULE:         List of elements with loadmore button
WHAT IT DOES:   Provides loadmore button functionality
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {

    function loadlist(el, settings) {
        this.list = el;

        $.extend(this, this._default);
        this.settings = $.extend({}, this._settings, settings || this.list.data());

        this.init();        
    }

    $.extend(loadlist.prototype, {

        _default: {
            content: null,
            loadmore: null,
            template: null,
            loadingTimeout: null,
            ajaxCall: null,
            ajaxTime: null,
            ajaxTimeout: null
        },

        _settings: {
            url: '',
            page: 0,
            total: 0,
            template: '',
            loadtimeout: 1000,
            mintimeout: 1500
        },

        init: function () {
            this.content = this.list.find('.js-loadlist-content');
            this.loadmore = this.list.find('.js-loadlist-loadmore');

            if (!this.content.length || !this.loadmore.length)
                return;

            //update settings
            this.settings.page = parseInt(this.settings.page);
            this.settings.total = parseInt(this.settings.total);

            //requiring libraries
            if (typeof this.Handlebars == 'undefined')
                this.Handlebars = require('handlebars');

            //templates
            if (this.settings.template) {
                var templateSource = $('#' + this.settings.template);
                if (templateSource.length)
                    this.template = this.Handlebars.compile(templateSource.html());
            }

            this.loadmore.on('click', this.loadmoreProcess.bind(this));
            this.loadmoreCheck();
        },

        loadmoreProcess: function (e) {
            if (typeof e != 'undefined' && typeof e.preventDefault == "function")
                e.preventDefault();
            this.callToLoadNewItems();
        },

        callToLoadNewItems: function () {
            if (this.loadingTimeout)
                clearTimeout(this.loadingTimeout);
            this.loadingTimeout = setTimeout(this.loadNewItems.bind(this), this.settings.loadtimeout);
        },

        loadmoreCheck: function () {
            if (this.settings.page > this.settings.total) {
                this.loadmore.hide();
            }
        },

        loadNewItems: function () {
            if (!this.settings.url.length)
                return;

            var data = {
                page: this.settings.page
            };

            this.ajaxAbort();

            this.content.addClass('loading');

            this.ajaxCall = $.ajax({
                method: "POST",
                url: this.settings.url,
                dataType: "json",
                data: data,
                success: this.ajaxSuccess.bind(this),
                error: this.ajaxError.bind(this)
            });
        },

        ajaxSuccess: function (data) {
            var newDate = new Date(),
                diff = newDate - this.ajaxTime;
            if (diff < this.settings.mintimeout) {
                setTimeout(this.ajaxSuccess.bind(this, data), this.settings.mintimeout - diff + 1);
                return;
            }

            var newPageId = data.page;
            if(newPageId != this.settings.page + 1)
                return;

            this.settings.page = newPageId;

            this.content.append($(this.template(data)));

            this.content.removeClass('loading');

            this.loadmoreCheck();
        },

        ajaxError: function () {
            this.content.removeClass('loading');
        },

        ajaxAbort: function () {
            if (this.ajaxCall && typeof this.ajaxCall.abort == "function") {
                try {
                    ajaxCall.abort();
                } catch (ex) { }
            }
            if (this.ajaxTimeout)
                clearTimeout(ajaxTimeout);
            this.ajaxTime = new Date();
        }
    });

    return loadlist;

}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/generic/generic.loadlist.js
 ** module id = 25
 ** module chunks = 24
 **/